<template>
  <div class="business-info" v-loading="infoLoading">
    <div class="btn-group">
      <template v-if="!(typeof(actionData.customerghkh_editandsave) != 'undefined'&&!actionData.customerghkh_editandsave)">
        <el-button v-if="!isEdit" type="primary" size="medium" @click="isEdit=true;loadList">编辑</el-button>
        <el-button v-else type="primary" size="medium" @click="save" >保存</el-button>
      </template>
    </div>
    <el-row :gutter="20" v-if="!isEdit">
      <el-col :span="12">
        <h2 class="title">负责人信息</h2>
        <div class="item">
          <span class="label">对接负责人：</span>
          <div class="value">{{bussessInfo.jointerName||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">销售负责人：</span>
          <div class="value">{{bussessInfo.salerName||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">外部销售负责人：</span>
          <div class="value">{{bussessInfo.exterSalerName||'--'}}&emsp;{{bussessInfo.handset}}&emsp;{{bussessInfo.companyName}}</div>
        </div>
        <div class="item">
          <span class="label">客户成功部负责人：</span>
          <div class="value">{{bussessInfo.custSuccName||'--'}}</div>
        </div>
      </el-col>
      <el-col :span="12">
        <h2 class="title">其它信息</h2>
        <div class="item">
          <span class="label">主要需求领域：</span>
          <div class="value">{{bussessInfo.domainName||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">产线：</span>
          <div class="value">{{bussessInfo.prodLine||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">预计发单量：</span>
          <div class="value">{{bussessInfo.billNumber||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">预计发单金额：</span>
          <div class="value">{{bussessInfo.billAmount||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">预计发单高峰期：</span>
          <div class="value">{{bussessInfo.billTimeName||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">业主方联系人：</span>
          <div class="value">{{bussessInfo.owner||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">业主方联系方式：</span>
          <div class="value">{{bussessInfo.ownerPhone||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">客户级别：</span>
          <div class="value">{{bussessInfo.level||'--'}}</div>
        </div>
        <div class="item">
          <span class="label">用户特点：</span>
          <div class="value">{{bussessInfo.custFeature||'--'}}</div>
        </div>
      </el-col>
    </el-row>
    <el-form 
      v-else
      ref="form" 
      label-width="140px" 
      label-position="left" 
      :model="form"
      :rules="rules"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <h2 class="title">负责人信息</h2>
          <el-form-item label="对接负责人：" prop="jointerName">
            <el-select v-model="form.jointerId" filterable clearable value-key="userId">
              <el-option
                v-for="item in dockingList"
                :key="item.userId"
                :value="item.userId"
                :label="item.userName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售负责人：" prop="salerNam">
            <el-select v-model="form.salerId" filterable clearable value-key="userId">
              <el-option
                v-for="item in salesList"
                :key="item.userId"
                :value="item.userId"
                :label="item.userName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外部销售负责人：" prop="exterSalerName">
            <el-select v-model="form.exterSalerId" filterable clearable value-key="userId">
              <el-option
                v-for="(item,index) in externalSalesList"
                :key="index"
                :value="item.userId"
                :label="item.userName"
              >
                <span style="float:left;min-width:3em;">{{ item.userName }}</span>
                <span style="float:left;padding-left:10px;">{{ item.handset }}</span>
                <span style="float:right;padding-left:10px;">{{ item.companyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户成功部负责人：" prop="custSuccName">
            <el-select v-model="form.custSuccId" filterable clearable value-key="userId">
              <el-option
                v-for="item in successList"
                :key="item.userId"
                :value="item.userId"
                :label="item.userName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <h2 class="title">其它信息</h2>
          <el-form-item label="主要需求领域：" prop="prodDomainId">
            <el-select v-model="form.prodDomainId" filterable clearable value-key="key">
              <el-option
                v-for="item in domainList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产线：" prop="prodLine">
            <el-input v-model.trim="form.prodLine" ></el-input>
          </el-form-item>
          <el-form-item label="预计发单量：" prop="billNumber">
            <el-input v-model.number="form.billNumber" ></el-input>
          </el-form-item>
          <el-form-item label="预计发单金额：" prop="billAmount">
            <el-input v-model.number="form.billAmount" ></el-input>
          </el-form-item>
          <el-form-item label="预计发单高峰期：" prop="billTime">
            <el-select v-model="form.billTime" filterable clearable value-key="key">
              <el-option
                v-for="item in quarterList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业主方联系人：" prop="owner">
            <el-input v-model.trim="form.owner" ></el-input>
          </el-form-item>
          <el-form-item label="业主方联系方式：" prop="ownerPhone">
            <el-input v-model.number="form.ownerPhone" ></el-input>
          </el-form-item>
          <el-form-item label="客户级别：" prop="level">
            <el-select 
              v-model.trim="form.level" 
              placeholder="请选择" 
              style="width: 100%;"
            >
              <el-option 
                  v-for="(item, index) in levelArr" 
                  :key="index"
                  :value="item.value" 
                  :label="item.value" 
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户特点：" prop="custFeature">
            <!-- <el-input v-model.number="form.custFeature" ></el-input> -->
            <el-input placeholder="请输入用户特点"  
                    type="textarea" 
                    size="medium" 
                    :autosize="{ minRows: 3 }"
                    style=" width:100%;" 
                    v-model="form.custFeature"
                    :maxlength="350"
                    :show-word-limit="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
  </div>
</template>
<script>
import {
  busInfo,
  busInfoUpdate,
} from '@/service/customerInformation.js';
import {
  quarter,
  headers,
  getDomianSelect,
} from '@/service/area.js';
import { 
    getActionData
} from '@/utils/store'
export default {
  data(){
    return{
      actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用

      infoLoading: false,

      bussessInfo:{},
      form:{
        jointerName:'',
        jointerId:'',
        salerName:'',
        salerId:'',
        exterSalerName:'',
        exterSalerId:'',
        custSuccName:'',
        custSuccId:'',
        prodDomainId:'',
        domainName:'',
        prodLine:'',
        billNumber:'',
        billAmount:'',
        billTime:'',
        owner:'',
        ownerPhone:'',
        level: '',    //客户级别
        custFeature:''
      },
      isEdit:false,
      dockingList:[],//对接负责人
      salesList:[],//销售负责人
      externalSalesList:[],//外部销售负责人
      successList:[],//客户成功部负责人
      quarterList:[],//季度列表
      domainList:[],//领域
      rules:{},
      levelArr: [
          {
              value: 'A'
          },
          {
              value: 'B'
          },
          {
              value: 'C'
          }
      ],
    }
  },
  created() {
    this.loadList();
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadList(){
      //季度列表
      quarter().then(r=>{
        if(r.Result==1){
          this.quarterList=r.Data ||[];
        }
      }),
      //需求领域
      getDomianSelect().then(r=>{
        if(r.Result==1){
          this.domainList=r.Data ||[];
        }
      }),
      //对接负责人
      headers({
        headerType:3
      }).then(r=>{
        if(r.Result==1){
          this.dockingList=r.Data ||[];
        }
      })
      //销售负责人
      headers({
        headerType:1
      }).then(r=>{
        if(r.Result==1){
          this.salesList=r.Data ||[];
        }
      })
      //外部销售负责人
      headers({
        headerType:2
      }).then(r=>{
        if(r.Result==1){
          this.externalSalesList=r.Data ||[];
        }
      })
      //客户成功部负责人
      headers({
        headerType:4
      }).then(r=>{
        if(r.Result==1){
          this.successList=r.Data ||[];
        }
      })
    },
    //获取信息
    loadData(){
      this.infoLoading = true
      this.isEdit = false;
      let custId=Number(this.$route.query.custId);
      busInfo({
        custId:custId,
      }).then(r=>{
        if(r.Result==1){
          this.infoLoading = false
          let data=r.Data || {};
          this.bussessInfo=data;
          for (const k in this.form) {
            if (Object.hasOwnProperty.call(this.form, k)) {
              this.form[k]=data[k];
            }
          }
          this.form.billNumber = data.billNumber <= 0?'':data.billNumber
          this.form.billAmount = data.billAmount <= 0?'':data.billAmount
          this.form.jointerId = data.jointerId <= 0?'':data.jointerId
          this.form.salerId = data.salerId <= 0?'':data.salerId
          this.form.exterSalerId = data.exterSalerId <= 0?'':data.exterSalerId
          this.form.custSuccId = data.custSuccId <= 0?'':data.custSuccId
          this.form.prodDomainId = data.prodDomainId <= 0?'':data.prodDomainId+''
          //  this.form.custFeature = data.custFeature;

          console.log("form:"+JSON.stringify(  this.form))
        }
      })
    },
    //保存
    save(){
      let custId=Number(this.$route.query.custId);
      this.$refs.form.validate(valid=>{
        if(valid){
          let params={
            ...this.form,
            pkid:custId,
          }
          // !params.jointerId && delete params.jointerId
          // !params.salerId && delete params.salerId
          // !params.exterSalerId && delete params.exterSalerId
          // !params.custSuccId && delete params.custSuccId
          // !params.prodDomainId && delete params.prodDomainId
          // !params.billTime && delete params.billTime

          if(params.jointerId <= 0 || !params.jointerId) params.jointerId = -1
          if(params.salerId <= 0 || !params.salerId) params.salerId = -1
          if(params.exterSalerId <= 0 || !params.exterSalerId) params.exterSalerId = -1
          if(params.custSuccId <= 0 || !params.custSuccId) params.custSuccId = -1
          if(params.prodDomainId <= 0 || !params.prodDomainId) params.prodDomainId = -1
          if(params.billTime <= 0 || !params.billTime) params.billTime = -1
          if(!params.billNumber) params.billNumber = 0
          if(!params.billAmount) params.billAmount = 0

          busInfoUpdate(params).then(r=>{
            if(r.Result==1){
              this.$message.success('编辑成功')
              this.isEdit=false;
              this.loadData();
            }else{
              this.$message.info(r.Message);
            }
          })
        }
      })
    }
  },
}
</script>
<style lang="scss">
.business-info{
  position: relative;
  .btn-group{
    position: absolute;
    right: 0;
    top: 0px;
    z-index: 3;
  }
  .el-select{
    width: 100%;
  }
  .el-col{
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      margin-bottom: 20px;
		}
    .item{
      margin-bottom: 10px;
      overflow: hidden;
    }
    .label{
      float: left;
      width: 140px;
      font-size: 14px;
      color: #333;
      padding: 5px 10px 5px 0;
      line-height: 24px;
      box-sizing: border-box;
    }
    .value{
      float: left;
      width: calc(100% - 140px);
      font-size: 14px;
      color: #333;
      padding: 5px 10px 5px 0;
      line-height: 24px;
      box-sizing: border-box;
      word-break: break-all;
    }
  }
}
</style>